import * as React from 'react'

import {Box, Typography} from "@mui/material";
import {batch} from "@preact/signals-react";
import {IconSeeker} from "@ui-seeker/core";

import {commonFiltersValue} from "@signals";
import {shareOfSearchStatusScoreFilters} from "../../@signals";


export default function keywordColumn() {
    return {
        name: 'keyword', label: 'Keyword',
        options: {
            customBodyRowRenderLite: (value, row) => <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                {value}

                {row.score !== 0 && <ShowPositionCell  keywordID={row.keywordID}/>}
            </Box>
        }
    }
}

const ShowPositionCell = ({ keywordID }) => {

    const handleClick = () => { batch(() => {
        shareOfSearchStatusScoreFilters.value = {
            ...commonFiltersValue.peek(),
            keyword: [keywordID]
        }
    })}

    return <Box data-tour-trigger sx={{ display: 'flex', alignItems: 'flex-end'}} onClick={handleClick} >
        <Typography variant="caption" sx={{ display: 'block', color: "text.primary", mt: 1, mr: 0.5, cursor: 'pointer', "&:hover":{ textDecoration: 'underline'} }}>
            Show Keyword Score in All Retailers
        </Typography>
        <IconSeeker icon={'chart-line'} sx={{ mr: 0.5, margin: .5, color: 'primary.main'}}/>
    </Box>

}